document.addEventListener("DOMContentLoaded", () => {
  const products = document.querySelectorAll(".product-item-new");

  products.forEach((product) => {
    const paletteInputs = product.querySelectorAll('input[type="radio"]');
    const descBox = product.querySelector(".variant-description");

    const updateDescription = (input) => {
      const text = input.dataset.description || "";
      descBox.innerHTML = "";
      if (text) {
        const span = document.createElement("span");
        span.textContent = text;
        descBox.appendChild(span);
      }
    };

    const updateProductView = (input) => {
      const productItem = input.closest(".product-item-new");

      const mainImg = productItem.querySelector(".image-link img");
      if (mainImg && input.dataset.image) {
        mainImg.src = input.dataset.image;
      }

      const priceBox = productItem.querySelector(".price");
      if (priceBox && input.dataset.price) {
        const oldCompare = priceBox.querySelector(".price-with-compare");
        if (oldCompare) oldCompare.remove();

        let moneySpan = priceBox.querySelector(".money");
        if (!moneySpan) {
          moneySpan = document.createElement("span");
          moneySpan.classList.add("money");
          priceBox.prepend(moneySpan);
        }

        moneySpan.textContent = input.dataset.price;
        moneySpan.setAttribute("data-currency-eur", `€${input.dataset.price}`);
        moneySpan.setAttribute("data-currency", "EUR");

        if (
          input.dataset.compare &&
          input.dataset.compare !== input.dataset.price
        ) {
          const div = document.createElement("div");
          div.classList.add("price-with-compare");
          div.innerHTML = `
            <span class="money" data-currency-eur="€${input.dataset.price}" data-currency="EUR">${input.dataset.price}</span>
            <em class="marked-down-from">
              <span class="money" data-currency-eur="€${input.dataset.compare}" data-currency="EUR">${input.dataset.compare}</span>
            </em>
          `;

          const button = priceBox.querySelector(".purchase.button");
          if (button) {
            priceBox.insertBefore(div, button);
            moneySpan.remove();
          }
        }
      }

      const link = productItem.querySelector(".purchase.button");
      if (link && input.dataset.url) {
        link.href = input.dataset.url;
      }

      const imageLink = productItem.querySelector(".image-wrapper");
      if (imageLink && input.dataset.url) {
        imageLink.href = input.dataset.url;
      }

      const titleLink = productItem.querySelector(".title a");
      if (titleLink && input.dataset.url) {
        titleLink.href = input.dataset.url;
      }

      const extraDesc = productItem.querySelector(".variant-extra-description");
      if (extraDesc && input.dataset.url) {
        extraDesc.href = input.dataset.url;
      }

      const vendorLink = productItem.querySelector(".vendor a");
      if (vendorLink && input.dataset.url) {
        vendorLink.href = input.dataset.url;
      }
    };

    if (paletteInputs.length > 0) {
      const allLis = product.querySelectorAll(".clio-palette-selector-new li");
      allLis.forEach((l) => l.classList.remove("active"));

      let selectedInput = null;

      if (!product.classList.contains("is_variant")) {
        // selectedInput = paletteInputs[0];
        // selectedInput =
        //   Array.from(paletteInputs).find(
        //     (inp) => !inp.classList.contains("disabled")
        //   ) || paletteInputs[0];
      } else {
        const featuredId =
          product.dataset.featuredVariantId ||
          product.getAttribute("data-featured-variant-id") ||
          null;

        if (featuredId) {
          selectedInput = Array.from(paletteInputs).find(
            (inp) => inp.dataset.id == featuredId
          );
        }

        if (!selectedInput) {
          selectedInput =
            product.querySelector('input[type="radio"][checked]') || null;
        }

        if (!selectedInput) {
          selectedInput = paletteInputs[0];
        }
      }

      if (selectedInput) {
        const li = selectedInput.closest("li");
        if (li && li.classList.contains("hidden-variant")) {
          const paletteList = product.querySelector(
            ".clio-palette-selector-new"
          );
          const visibleLis = paletteList.querySelectorAll(
            "li:not(.hidden-variant):not(.more-variants)"
          );
          const lastVisible = visibleLis[visibleLis.length - 1];

          if (lastVisible) {
            li.classList.remove("hidden-variant");
            lastVisible.classList.add("hidden-variant");
          }
        }

        selectedInput.checked = true;
        if (li) li.classList.add("active");
        updateDescription(selectedInput);
        updateProductView(selectedInput);
      }
    }

    paletteInputs.forEach((input) => {
      input.addEventListener("change", () => {
        const siblingLis = product.querySelectorAll(
          ".clio-palette-selector-new li"
        );

        siblingLis.forEach((sibling) => sibling.classList.remove("active"));

        const li = input.closest("li");
        if (li) li.classList.add("active");

        updateDescription(input);
        updateProductView(input);
      });
    });
  });
});
